/**
 * useBodyScrollLock - Strong overlay scroll lock using position:fixed pattern
 *
 * On mobile, overflow:hidden alone is insufficient. This hook:
 * 1. Stores current scrollY on lock
 * 2. Sets body to position:fixed with top offset
 * 3. Restores scroll position on unlock
 *
 * This prevents background scroll AND Chrome bottom bar flickering.
 */
import { useEffect, useRef } from 'react';

export function useBodyScrollLock(locked: boolean): void {
  const scrollYRef = useRef(0);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    if (locked) {
      scrollYRef.current = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollYRef.current}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollYRef.current);
    }

    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollYRef.current);
    };
  }, [locked]);
}

export default useBodyScrollLock;
